<template>
<div class="chapter">
<div class="inner_page">
<p class="h2" id="p52"><span><a href="#/Contents#rp52">RED ONION AND APPLE SOUP WITH CURRY</a></span></p>
<p class="imagel"><span><img alt="" height="5" src="images/line-3.jpg" width="532"/></span></p>
<p class="normal"><span><i>Red onions, cooked until sweet and tender, lend a special flavor to this autumn soup.</i></span></p>
<p class="make"><span>6 first-course servings</span></p>
<p class="hang"><span>1¼ pounds red onions (about 4 medium), thinly sliced</span></p>
<p class="hang"><span>1 tablespoon margarine or butter</span></p>
<p class="hang"><span>1½ quarts Rich Chicken Stock (see <a href="#/Chapter014#p4">p. 4</a>)</span></p>
<p class="hang"><span>2 cups coarsely grated peeled tart cooking apples, divided</span></p>
<p class="hang"><span>½ cup coarsely shredded carrots</span></p>
<p class="hang"><span>1 large bay leaf</span></p>
<p class="hang"><span>1 teaspoon each: curry and chili powder</span></p>
<p class="hang"><span>¼ teaspoon each: dried thyme leaves, ground allspice</span></p>
<p class="hang"><span>Salt and pepper, to taste</span></p>
<p class="hang"><span>Mango chutney, as garnish</span></p>
<p class="normalt"><span><a id="page_40"></a><b>1.</b> Sauté onions in margarine in large saucepan until tender and lightly browned, about 15 minutes. Stir in stock, 1 cup apples, carrots, and seasonings; heat to boiling. Reduce heat and simmer, covered, until vegetables are tender, about 20 minutes, adding remaining 1 cup apples during last 5 minutes. Discard bay leaf; season to taste with salt and pepper. Serve with chutney to stir into soup.</span></p>
<p class="per"><span>Per Serving:</span></p>
<p class="per1"><span>Calories: 106</span></p>
<p class="per1"><span>% calories from fat: 18</span></p>
<p class="per1"><span>Protein (g): 6.4</span></p>
<p class="per1"><span>Carbohydrate (g): 16.4</span></p>
<p class="per1"><span>Fat (g): 2.3</span></p>
<p class="per1"><span>Saturated fat (g): 0.4</span></p>
<p class="per1"><span>Cholesterol (mg): 0</span></p>
<p class="per1"><span>Sodium (mg): 393</span></p>
<p class="per"><span>Exchanges:</span></p>
<p class="per1"><span>Milk: 0.0</span></p>
<p class="per1"><span>Vegetable: 2.0</span></p>
<p class="per1"><span>Fruit: 0.5</span></p>
<p class="per1"><span>Bread: 0.0</span></p>
<p class="per1"><span>Meat: 0.0</span></p>
<p class="per1"><span>Fat: 0.5</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Chapter0233.vue?80362842